import Modal from "components/Modal/Modal";
import { useAppDispatch } from "hooks/hooks";
import {
  deletePayedPayment,
  getAllAccountPayables,
  selectPayablePaymentForDeletion,
  selectState,
  setIndexesForPaymentDeletion,
} from "../accountPayable.slice";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { selectPartner } from "../../Main/main.slice";
import { FormatDate } from "utils/dateUtils";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";

const DeletePaidPaymentModal = () => {
  const dispatch = useAppDispatch();
  const { deletePayedPaymentModalOpen } = useSelector(selectState);
  const data = useSelector(selectPayablePaymentForDeletion);
  const partner = useSelector(selectPartner);

  const close = () => {
    dispatch(setIndexesForPaymentDeletion(undefined));
  };

  const doDelete = async () => {
    try {
      if (data) {
        await dispatch(deletePayedPayment(data?.payment.paidPaymentId)).unwrap();
        dispatch(getAllAccountPayables(partner.partnerId));
        toast.success("Uplata je uspešno obrisana.");
        close();
      }
    } catch (status: any) {
      close();
      if (status === 404) {
        toast.error("Uplata koju tražite da se obriše ne postoji");
      } else if (status === 400) {
        toast.error("Brisanje nije moguće zbog neočekivane greške");
      }
    }
  };

  return (
    <Modal
      isOpen={deletePayedPaymentModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje uplate"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeću uplatu?
        <br />
        <br />
        <b>
          Br. fakture - {data && data.reference}
          <br />
          Datum - {data && FormatDate(data.payment.date)}
          <br />
          Iznos - {FormatNumberWithUnitOrNull(data?.payment.amount, 'rsd')}
        </b>
      </p>
    </Modal>
  );
};

export default DeletePaidPaymentModal;
